/* eslint-disable @direct-frontend/modules/prefer-persistent-slices -- именно этот паттерн используется */
import type { PersistStorage } from '@direct-frontend/modules-store';

export const localStorageAdapter: PersistStorage = {
    async getItem(key) {
        const value = window.localStorage.getItem(key);

        return value === null ? value : JSON.parse(value);
    },
    async setItem(key, value) {
        return window.localStorage.setItem(key, JSON.stringify(value));
    },
    async removeItem(key) {
        return window.localStorage.removeItem(key);
    },
};
